// utils/storageFiles.js
import { db, storage } from "../firebase/firebase.utils";
import { setFiles } from "../redux/files/files.reducer";

export function subscribeFiles({ spaceId, stationId, userId, canViewWorkspace, dispatch }) {
  const key = JSON.stringify([userId, spaceId, stationId]);
  let active = true;
  dispatch(setFiles({ key, reset: true, workspaceLoading: canViewWorkspace }));
  const base = db.collection("storageFiles").where("status", "==", "ready").where("spaceId", "==", spaceId);
  const listen = (query, scope) =>
    query.onSnapshot(
      (snap) => {
        if (active)
          dispatch(
            setFiles({
              key,
              [scope]: snap.docs.map((d) => ({ ...d.data(), id: d.id })),
              [`${scope}Loading`]: false,
              [`${scope}Error`]: "",
            }),
          );
      },
      () => {
        if (active)
          dispatch(
            setFiles({
              key,
              [scope]: [],
              [`${scope}Loading`]: false,
              [`${scope}Error`]: "Files could not be loaded. Check your access or try again.",
            }),
          );
      },
    );
  const stops = [
    listen(base.where("stationId", "==", stationId).where("group", "in", ["project", "photos"]), "project"),
  ];
  if (canViewWorkspace) stops.push(listen(base.where("group", "==", "workspace"), "workspace"));
  return () => {
    active = false;
    stops.forEach((stop) => stop());
  };
}
export const openFile = (file) => storage.ref(file.fullPath).getDownloadURL();
export const deleteFile = (file) => storage.ref(file.fullPath).delete();
export const moveFile = (file, folder) => db.collection("storageFiles").doc(file.id).update({ folder });
